import { useTranslation } from 'react-i18next'
import { useState } from "react"
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import dayjs from "dayjs";


const LanguageSwap = () => {
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState(i18n.language);
  const toggleTheme = () => {
    const nextValue = lang === 'fr' ? 'en' : 'fr'
    setLang(nextValue);
    i18n.changeLanguage(nextValue)
    dayjs.locale(nextValue)
  };

  return (
    <ToggleButtonGroup
      color="primary"
      value={lang}
      exclusive
      size="small"
      onChange={toggleTheme}
      aria-label="Langage"
    >
      <ToggleButton value="fr" size="small">{t("labels.french")}</ToggleButton>
      <ToggleButton value="en" size="small">{t("labels.english")}</ToggleButton>
    </ToggleButtonGroup>
  );
}
export default LanguageSwap
